angular.module("ainapp")
    .controller("vacationJoinController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Vacation Join";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.Employees = [];
            MainService.EmployeesInDropdown().then(function (response) {
                $scope.Employees = response.data;
            }, function (err) {
                toastr.error($scope.LanguageData.NetworkError);
            })

            $scope.Init = function () {
                $scope.addData = {
                    EmployeeId: "",
                    Date: new Date(),
                    FromDate: new Date(),
                    ToDate: new Date(),
                    RejoinDate: new Date(),
                    Remarks: "",
                }

                MainService.GetNextVacationJoinNo().then(function (response) {
                    $scope.addData.VoucherNumber = response.data;
                })

                $scope.load = 0;

            }
            $scope.Init();

            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        MainService.VacationJoinsInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error($scope.LanguageData.NetworkError);
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            "Employee.Name": {
                                type: "string",
                                editable: false,
                            },
                            VoucherNumber: {
                                type: "string",
                                editable: false,
                            },
                            Date: {
                                type: "date",
                                editable: false,
                            },
                            FromDate: {
                                type: "date",
                                editable: false,
                            },
                            ToDate: {
                                type: "date",
                                editable: false,
                            },
                            RejoinDate: {
                                type: "date",
                                editable: false,
                            },
                            Remarks: {
                                type: "string",
                                editable: false,
                            },


                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },
                columns: [
                    {
                        field: "Employee.Name",
                        title: "Employee",
                        },
                    {
                        field: "VoucherNumber",
                        title: "Voucher No",
                        },
                    {
                        field: "Date",
                        title: "Date",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        },
                    {
                        field: "FromDate",
                        title: "From Date",
                        template: "#= kendo.toString(kendo.parseDate(FromDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        },
                    {
                        field: "ToDate",
                        title: "To Date",
                        template: "#= kendo.toString(kendo.parseDate(ToDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        },
                    {
                        field: "RejoinDate",
                        title: "Rejoin Date",
                        template: "#= kendo.toString(kendo.parseDate(RejoinDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        },
                    {
                        field: "Remarks",
                        title: "Remarks",
                        },
                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}  ",
                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-trash'  ng-click='DeleteAccType(dataItem)'></button>  ",
                        width: '80px'
                    },
                    ],
            };

            $scope.Update = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.sync();
            }
            $scope.Cancel = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.cancelChanges();
            }

            $scope.SelectedDataForDelete = {};
            $scope.DeleteAccType = function (data) {
                if (!$scope.PageAccessInfo.IsRemove) {
                    toastr.info($scope.LanguageData.YouDontHaveAccessToDeleteData);
                } else {
                    $scope.SelectedDataForDelete = data;
                    $("#deleteModal").modal("show");
                }
            }

            $scope.deleteWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteVacationJoin($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data) {
                        $('#deleteModal').modal('hide');
                        toastr.success($scope.LanguageData.Deleted);
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataForDelete = {};
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error($scope.LanguageData.NetworkError);
                    $.LoadingOverlay("hide");
                });
            }

            $scope.Edit = function (data) {
                $scope.addData = data;
                $scope.addData.Date = new Date($scope.addData.Date);
                $scope.addData.FromDate = new Date($scope.addData.FromDate);
                $scope.addData.ToDate = new Date($scope.addData.ToDate);
                $scope.addData.RejoinDate = new Date($scope.addData.RejoinDate);
            }

            $scope.AddData = function () {
                if ($scope.addData.EmployeeId == "") {
                    toastr.warning("Select Employee");

                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    $scope.addData.DateString = $scope.extractDate($scope.addData.Date);
                    $scope.addData.FromDateString = $scope.extractDate($scope.addData.FromDate);
                    $scope.addData.ToDateString = $scope.extractDate($scope.addData.ToDate);
                    $scope.addData.JoinDateString = $scope.extractDate($scope.addData.RejoinDate);

                    MainService.SaveVacationJoin($scope.addData).then(function (response) {
                        if (response.data) {
                            $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                            toastr.success($scope.LanguageData.Success);
                            $scope.Init();
                        } else {
                            toastr.error($scope.LanguageData.Error);
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error($scope.LanguageData.NetworkError);
                        $.LoadingOverlay("hide");
                    });
                }
            }

                }])
